import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label", "aria-expanded"]
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "svg-inline": '',
  "aria-hidden": 'true',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_3 = {
  ref: "text",
  class: "notification-text"
}
const _hoisted_4 = { class: "notification-headline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "main",
    class: _normalizeClass(["notification", {
      'is-open': _ctx.isOpen,
      hasNews: _ctx.hasNews,
      animateFadeIn: _ctx.isStartup,
    }]),
    tabindex: "-1",
    onFocusout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFocusOut && _ctx.handleFocusOut(...args)))
  }, [
    _createElementVNode("button", {
      "aria-label": _ctx.$t('notificationBox.title.new'),
      "aria-expanded": _ctx.isOpen,
      "aria-controls": "notification-content",
      class: "notification-bubble",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleState && _ctx.toggleState(...args))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleState && _ctx.toggleState(...args)), ["enter"])),
      tabindex: "0"
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("path", { d: "M20 8l-8 5-8-5V6l8 5 8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2z" }, null, -1)
      ]))]))
    ], 40, _hoisted_1),
    _createElementVNode("div", {
      id: "notification-content",
      ref: "content",
      class: _normalizeClass(["notification-content", { hide: _ctx.hideContent }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleState && _ctx.toggleState(...args))),
      style: _normalizeStyle(_ctx.styleContent)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _withDirectives(_createElementVNode("div", {
          ref: "description",
          class: "notification-description",
          style: _normalizeStyle(_ctx.styleDescription)
        }, _toDisplayString(_ctx.description), 5), [
          [_vShow, _ctx.isOpen]
        ])
      ], 512),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "notification-control" }, null, -1))
    ], 6)
  ], 34))
}